import React, { useContext } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import RecipeCardFood from '../components/RecipeCardFood';
import SearchBar from '../components/SearchBar';
import context from '../context/recipesContext';
import FiltersFoods from '../components/FiltersFoods';
import './css/Foods.css';

function Foods() {
  const { foods, searchBarIsVisible } = useContext(context);
  const maxSize = 12;

  return (
    <div className="page-foods">
      <div>
        <Header Title="Foods" />
      </div>
      { searchBarIsVisible && <SearchBar page="foods" />}
      <FiltersFoods />
      <div className="results-section">
        {
          foods && (
            foods.slice(0, maxSize).map((recipe, index) => (
              <RecipeCardFood key={ index } index={ index } recipe={ recipe } />))
          )
        }
      </div>
      <Footer />
    </div>
  );
}

export default Foods;
